$(document).ready(function(){
  $('.product-selector_block').click(function(){
    var currentMode = $('.product-selector_outer.active_block').attr('data')
    var currentIndex = $(this).attr('data-index');

    $('.product-selector_block').removeClass('active');
    $(this).addClass('active');
    $('.product-selector_block[data-index="'+currentIndex+'"]').addClass('active');

    var indexOpt = $(this).attr("data-index");
    $(".product_atc-refills").addClass("hided");
    $('.product_atc-refills[data="' + indexOpt + '"]').removeClass("hided");

    $('.cta-note.changeble').addClass('hided');
    $('.cta-note.changeble[data-id="'+indexOpt+'"]').removeClass('hided');
    
  });

  $('.pp_var_autoship').click(function(){
    $(this).toggleClass('disabled');
    if ($('.pp_var_autoship').hasClass('disabled')){
      $('.product-selector_outer[data="sub"]').removeClass('active_block');
      $('.product-selector_outer[data="otp"]').addClass('active_block');
    }
    else{
      $('.product-selector_outer[data="sub"]').addClass('active_block');
      $('.product-selector_outer[data="otp"]').removeClass('active_block');
    }
  });


  $('.product-selector_atc_coc').click(function(){
        var newUrl = $(this).attr('data-coc-link');
        window.location.href = newUrl;
    });

    $(document).on("click", ".product-selector_atc", function (e) {
    e.preventDefault();

    var $btn = $(this);
    $btn.addClass("loading_hk");

    var $activeOuter = $(".product-selector_outer.active_block");
    var $activeBlock = $activeOuter.find(".product-selector_block.active");

    var currentId = $activeBlock.attr("data-id");
    var mode = $activeOuter.attr("data");
    var currentSellingPlan = $activeBlock.attr("data-selling-plan");

    var data = {
        id: currentId,
        quantity: 1,
    };

    if (mode === "sub" && currentSellingPlan) {
        data.selling_plan = currentSellingPlan;
    }

    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
        $.get(window.location.pathname, function (res) {
            var $res = $(res);

            // Replace cart drawer content
            var $newDrawerContent = $res.find("#cart_drawer_content");
            if ($newDrawerContent.length) {
            $("#cart_drawer_content").replaceWith($newDrawerContent);
            }

            // Update cart count
            var $newCartCount = $res.find(".cart_count_js");
            var cartCount = parseInt($.trim($newCartCount.text()), 10) || 0;

            if (cartCount > 0) {
            $(".cart_count_js").text(cartCount).show();
            } else {
            $(".cart_count_js").text("").hide();
            }

            // Open drawer
            $("#cart-drawer").removeClass("is_empty").addClass("open");
            $(".custom_overlay2").addClass("active");

            $btn.removeClass("loading_hk");
        }).fail(function () {
            $btn.removeClass("loading_hk");
            alert("Item added, but cart UI could not refresh.");
        });
        },
        error: function () {
        $btn.removeClass("loading_hk");
        alert("Error adding item to the cart.");
        },
    });
    });

});